import request from '@/utils/request';

const merchantApi = {
    // 查询商家信息
    queryGoodsMerchantInfo({id,brandId,classificationId,userId,phone,fullName,storeName,idCard,tradeStatus,province,city,area,town,status,queryLongitude,queryLatitude,page,size = 10,isPage = 1,merchantStatus,isAdSpace,discountConfigId}){
        return request({
            url: '/app/query/goods/merchant/info',
            method: 'post',
            data: {
                'id': id,
                'brandId': brandId,
                'classificationId': classificationId, // 分类ID
                'userId': userId, // 用户ID
                'phone': phone, // 手机号
                'fullName': fullName, // 商家姓名
                'storeName': storeName, // 商铺名称
                'idCard': idCard, // 商家身份证号码
                'tradeStatus': tradeStatus, // 营业状态，(0:已打烊,1:正常)
                'province': province, // 省份
                'city': city, // 城市
                'area': area, // 区域
                'town': town, // 城镇
                'status': status, // 状态，0：关闭，1：开启
                'queryLongitude': queryLongitude, // 查询经度
                'queryLatitude': queryLatitude, // 查询维度
                'merchantStatus': merchantStatus, // 商家状态 (0:审核中,1:已通过,2:已拒绝)
                'page': page,
                'size': size,
                'isPage': isPage, // 是否分页，0：否，1：是
                'isAdSpace': isAdSpace, // 是否展示广告位，0：否，1：是
                'discountConfigId': discountConfigId, // 商家让利配置ID
            }
        });
    },
    // 提交商家收款订单
    submitGoodsMerchantPaymentOrder({merchantId,paymentAmount,remarks,voucherImage,cardId}){
        return request({
            url: '/app/submit/goods/merchant/payment/order',
            method: 'post',
            data: {
                'merchantId': merchantId, // 商家ID
                'paymentAmount': paymentAmount, // 付款金额
                'remarks': remarks, // 备注
                'voucherImage': voucherImage, // 凭证图片
                'cardId': cardId, // 特权卡ID
            }
        });
    },
    // 商家收款订单支付
    payGoodsMerchantPaymentOrder({orderCode,payType,temptime,accountType}){
        return request({
            url: '/app/goods/merchant/payment/order/pay',
            method: 'post',
            data: {
                'orderCode': orderCode, // 订单号
                'payType': payType, // 付款方式，1:余额,2:支付宝,3:微信)
                'temptime': temptime,
                'accountType': accountType, // 抵扣账户类型
            }
        });
    },
    // 查询账户数据商品信息
    queryDataGoodsInfo({id,name,classificationId,isHot,isNeedUserId,accountType,page,size,brandId}){
        return request({
            url: '/app/query/data/goods/info',
            method: 'post',
            data: {
                'id': id,
                'brandId': brandId.toString(),
                'name': name,
                'classificationId': classificationId,
                'isHot': isHot, // 是否热门(0:否,1:是)
                'isNeedUserId': isNeedUserId, // 是否需要用户id(0:否,1:是(默认是不需要))
                'accountType': accountType,
                'sort': 'sort',
                'page': page,
                'size': size,
            }
        });
    }
}

export default merchantApi;